// extracted by mini-css-extract-plugin
export default {"list":"list_list__rWdvI","listItem":"list_listItem__wWuE8"};